import { faqItems } from '@/mocks/homepage';

export default function Faq() {
  return (
    <section id="faq" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于91视频网站的常见疑问解答</p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <div className="w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                    <span className="text-xs font-bold text-primary-600">Q</span>
                  </div>
                  <div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                      {item.q}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}